import { useMemo } from 'react';
import { type ContentfulEvent, type WebSection } from '@wbk/contentful/api';
import { useRouter, useTranslation } from '@wbk/config';
import { useGetEventsList } from '@/hooks/use-get-events';
import SameInterestEvent from './SameInterestEvent';

type Props = {
  event: ContentfulEvent;
};

const RecommendedCarousels = ({ event }: Props) => {
  const { locale } = useRouter();
  const { t } = useTranslation(['common']);

  const query = useMemo(() => {
    const where: Record<string, unknown> = {
      AND: [{ slug_not: event.slug }, { season: { slug: 'riyadh-season-2025' } }],
    };
    if (event.zone?.slug) {
      where.zone = { slug: event.zone.slug };
    }
    if (event.category?.slug) {
      where.category = { slug: event.category.slug };
    }

    return {
      lang: locale,
      limit: 12,
      where,
      order: 'order_ASC' as const,
    };
  }, [event.slug, event.zone?.slug, event.category?.slug, locale]);

  const { data } = useGetEventsList(query, { enabled: !!event });

  const items = data?.items || [];

  if (!items.length) return null;

  const section: WebSection = {
    id: 'recommended-events',
    title: t('common:recommended_for_you'),
    renderType: 'carousel',
    categoriesCollection: { items: [] },
    contentCollection: { items: items as unknown as WebSection['contentCollection']['items'] },
    webLinksCollection: { items: [] },
  } as unknown as WebSection;

  return (
    <section className='container py-40'>
      <SameInterestEvent section={section} />
    </section>
  );
};

export default RecommendedCarousels;
